
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/data-mapping-guide",
      function () {
        return require("private-next-pages/core-exchange/docs/data-mapping-guide/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/data-mapping-guide"])
      });
    }
  